import { Controller } from "@hotwired/stimulus"

// Muestra u oculta un bloque de campos según el valor de otro campo. A
// diferencia de disclosure (un toggle ciego), aquí importa QUÉ se eligió.
//
//   hideWhen       valor que oculta el bloque ("No hago clases...")
//   hideWhenBlank  ocultar también sin selección (registro: se parte sin nada)
//   showWhen       al revés: el bloque solo se muestra con este valor exacto
//   showWhenBlank  con showWhen: el vacío también cuenta como match (país aún
//                  no elegido → se asume la variante chilena)
//   sourceSelector selector CSS del campo observado cuando vive fuera de este
//                  elemento (ej: el hidden del combobox de país); si no, se usa
//                  el target `source` de adentro.
//
// Lo oculto además se deshabilita: dos variantes del mismo campo (malla
// chilena / genérica) comparten name y solo la visible debe viajar al server.
export default class extends Controller {
  static targets = ["source", "content"]
  static values = {
    hideWhen: String,
    hideWhenBlank: { type: Boolean, default: false },
    showWhen: String,
    showWhenBlank: { type: Boolean, default: false },
    sourceSelector: String,
  }

  connect() {
    this.externalSource = this.hasSourceSelectorValue
      ? document.querySelector(this.sourceSelectorValue)
      : null
    if (this.externalSource) {
      this.onSourceChange = () => this.refresh()
      this.externalSource.addEventListener("change", this.onSourceChange)
    }
    this.refresh()
  }

  disconnect() {
    this.externalSource?.removeEventListener("change", this.onSourceChange)
  }

  refresh() {
    const value = (this.externalSource || this.sourceTarget).value
    const hide = this.hasShowWhenValue
      ? !(value === this.showWhenValue || (this.showWhenBlankValue && value === ""))
      : value === this.hideWhenValue || (this.hideWhenBlankValue && value === "")

    this.contentTargets.forEach((el) => {
      el.classList.toggle("hidden", hide)
      el.querySelectorAll("input, select, textarea").forEach((campo) => {
        campo.disabled = hide
      })
    })
  }
}
